import { ArrowIcon } from "@cmsgov/ds-medicare-gov";
import React, { FunctionComponent, useContext } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { OecStatus } from "../../../../@types";
import { AnalyticsActionType } from "../../../../app/contexts/Analytics/types";
import { AppContext } from "../../../../app/store";
import {
  useTranslate,
  makePlanDetailsUrl,
  getPlanName,
  makePlanDisplayId,
} from "../../../../helpers";
import BasePlanCard from "./BasePlanCard";
import { CurrentCoverageCardProps } from "./CurrentCoverageCard";

export const oecEnrollmentCardTestId = "oec-enrollment-card";

interface FutureCoverageCardProps
  extends Omit<CurrentCoverageCardProps, "plan"> {
  oecStatus: OecStatus;
}

const EnrollmentConfirmationCard: FunctionComponent<FutureCoverageCardProps> = ({
  language,
  oecStatus,
  isOutsideOpenEnrollment,
}) => {
  const t = useTranslate();
  const { dispatch } = useContext(AppContext);
  const url = window.location.href.split("/summary?")[0];
  const linkText = t("summary_page.links.get_plan_details");
  const oecPlanDetailsLink = makePlanDetailsUrl({
    plan: oecStatus,
    language,
    yearValue: "year",
  });

  return (
    <BasePlanCard
      dataTestId={oecEnrollmentCardTestId}
      header={
        isOutsideOpenEnrollment ? (
          t("summary_page.plan_cards.future_coverage.OEC.header.OOE")
        ) : (
          <FormattedMessage
            id="summary_page.plan_cards.future_coverage.OEC.header.OE"
            values={{ year: oecStatus.year }}
          />
        )
      }
      subHeader={t("summary_page.plan_cards.future_coverage.OEC.subheader")}
      planHeader={
        <p className="mct-c-summary-page-plan-card__plan-header">
          {getPlanName(oecStatus, language)}
        </p>
      }
      planId={makePlanDisplayId(oecStatus)}
      extraInfo={
        <p className="mct-c-summary-page-plan-card__extra-info">
          <FormattedMessage
            id="summary_page.plan_cards.future_coverage.OEC.extra_info"
            values={{
              confirmationNumber: oecStatus.confirmation_number,
            }}
          />
        </p>
      }
      footer={
        <>
          <Link
            className="mct-c-summary-page-plan-card__link"
            to={oecPlanDetailsLink}
            onClick={() =>
              dispatch({
                type: AnalyticsActionType.SEND_INTERNAL_LINK_CLICKED_EVENT,
                settings: {
                  linkText,
                  linkUrl: `${url}${oecPlanDetailsLink}`,
                },
              })
            }
          >
            {linkText}
          </Link>
          <ArrowIcon className="ds-u-margin-left--05" direction="right" />
        </>
      }
    />
  );
};

export default EnrollmentConfirmationCard;
